import { zodResolver } from "@hookform/resolvers/zod";
import React, { useMemo } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { generateDefaultValues, schema, Schema } from "./schema";
import {
  ProjectsLocationsData,
  UpdateProjectLocationPayload
} from "../../../../../../models/ProjectData";
import { HookForm } from "../../../../../HookForm/HookForm";
import { HookFormTextarea } from "../../../../../HookForm/Textarea";

interface IProjectLocationCustomNotesFormProps {
  projectLocation: ProjectsLocationsData;
  handleSubmit: (payload: UpdateProjectLocationPayload) => void;
  handleClose: () => void;
}

export const ProjectLocationCustomNotesForm = (
  props: IProjectLocationCustomNotesFormProps
) => {
  const { projectLocation, handleSubmit, handleClose } = props;
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(
      `projectManagementPage.projectFacilityDetailsModal.projectLocationCustomNotes.${key}`
    );

  const defaultValues = useMemo(() => {
    return generateDefaultValues(projectLocation);
  }, [projectLocation]);

  const form = useForm<Schema>({
    resolver: zodResolver(schema),
    defaultValues
  });

  const onSubmit = async (data: Schema) => {
    const payload = {
      custom_notes: data.customNotes
    };
    handleSubmit(payload);
  };

  return (
    <div className="modal modal-default modal-project-location-custom-notes-form">
      <div className="modal-mains">
        <button className="btn-close" onClick={handleClose}></button>
        <div className="modal-mains__body">
          <HookForm
            onSubmit={onSubmit}
            form={form}
            submitButtonLabel={t("update")}
            onCancel={handleClose}
            showCancelButton
          >
            <HookFormTextarea label={t("custom_notes")} name="customNotes" />
          </HookForm>
        </div>
      </div>
    </div>
  );
};
